import React, { useEffect, useRef } from "react";
import "./IndustrySectors.css";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import aviationImg from "../Assessts/homeImages/rafele1.png";
import aviationHover from "../Assessts/homeImages/rafele1_hover.png";
import defenceImg from "../Assessts/homeImages/s400.png";
import defenceHover from "../Assessts/homeImages/s400-hover.png";
import railway from "../Assessts/homeImages/Railway.png";
import railwayHover from "../Assessts/homeImages/Railway-hover.png";
import aerospace from "../Assessts/homeImages/aerospace.png";
import aerospaceHover from "../Assessts/homeImages/aerospace-hover.png";
import drone from "../Assessts/homeImages/UAV.png";
import droneHover from "../Assessts/homeImages/UAV-hover.png";
import warshipImg from "../Assessts/homeImages/warship.png";
import warshipHover from "../Assessts/homeImages/warship-hover.png";

const sectors = [
  { id: "navy", title: "NAVY", defaultImg: warshipImg, hoverImg: warshipHover },
  { id: "airforce", title: "AIRFORCE", defaultImg: aviationImg, hoverImg: aviationHover },
  { id: "miltary", title: "MILITARY", defaultImg: defenceImg, hoverImg: defenceHover },
  { id: "aerospace", title: "AEROSPACE", defaultImg: aerospace, hoverImg: aerospaceHover },
  { id: "drones", title: "DRONES/UAV", defaultImg: drone, hoverImg: droneHover },
  { id: "railway", title: "RAILWAY", defaultImg: railway, hoverImg: railwayHover },
];

export default function IndustrySectors() {
  const headingRef = useRef(null);
  const gridRef = useRef(null);
  const paragraphRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle("in-view", entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );

    [headingRef, gridRef, paragraphRef].forEach(ref => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="container my-5">
      {/* Heading */}
      <div className="sector-text-full" ref={headingRef} style={{ marginTop: "50px" }}>
        <h2 className="fw-bold mb-4" style={{ color: "#074f86ff" }}>
          Technocrat Aerospace And Defence
        </h2>
      </div>

      {/* GRID */}
      <div className="sector-grid" ref={gridRef}>
        {sectors.map((sector, index) => (
          <Link to={`/sector/${sector.id}`} key={index} className="sector-card-link">
            <div className="sector-card">
              <img src={sector.defaultImg} alt={sector.title} className="default-img" />
              <img src={sector.hoverImg} alt={sector.title} className="hover-img" />
              <div className="overlay">
                <h5>{sector.title}</h5>
                <ChevronRight size={25} className="arrow" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      {/* TEXT */}
      <div className="sector-text-full mt-5" ref={paragraphRef}>
        <p style={{
    textAlign: "left",
    left: "8%",
    right: "auto",
    transform: "none",
  }}>
          Technocrat Aerospace and Defence Pvt Ltd is an <b>ISO 9001:2015 certified company</b>,
          reflecting its commitment to globally recognized quality management standards.
          The company is a leading technology integrator delivering <b>innovative solutions</b> for
          aerospace and defence sectors — spanning <b>data acquisition systems, RF modules,
          rugged computing, avionics interfaces, sensors, cable harnesses,</b> and more.
        </p>
        <p style={{
    textAlign: "left",
    left: "8%",
    right: "auto",
    transform: "none",
  }}>
          Its portfolio includes DAQ systems for <b>test and telemetry</b>, RF modules for
          <b> radar and communication systems</b>, rugged COTS hardware for <b>harsh
          environments</b>, and <b>custom cockpit controls</b>. The company also provides
          <b> build-to-print manufacturing</b> and <b>turnkey system integration</b> for
          <b> radar, EW, and platform monitoring solutions.</b>
        </p>
      </div>
    </div>
  );
}
